import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from 'libs.nucleus';
import { getDcrStatusBadgeVariant, getDcrStatusLabel } from '../../utils';
export const DcrStatusBadge = ({ status }) => {
    if (!status) {
        return null;
    }
    return (_jsx(Badge, { label: getDcrStatusLabel(status), variant: getDcrStatusBadgeVariant(status), dataTestId: 'dcr-status-badge' }));
};
